import { IDecideNextStep } from "../../services/wizard/next-step-decider/next-step-decider.interface";
import { PullExistingApplicationStepComponent } from "../../wizard/wizard-steps/pull-existing-application-step/pull-existing-application-step.component";
import { WizardStepBase } from "./wizard-step-base.model";

export class PullExistingApplicationStep extends WizardStepBase {
  constructor(id: string, name: string, path: string, nextStepDecider?: IDecideNextStep) {
    super(id, name, path, nextStepDecider);
    this.component = PullExistingApplicationStepComponent;
  }
}
